(function () {
    'use strict';

    angular.module('swif.publicLightning')
        .constant('swifPublicLightningConstant', {
            request: {
                content_type: 'intervention_request',
                routes: {
                    table_view: '/public-lightning/requests/table_view',
                    explorer_view: '/public-lightning/requests/explorer_view'
                }
            },
            intervention: {
                content_type: 'intervention',
                routes: {
                    table_view: '/public-lightning/interventions/table_view',
                    explorer_view: '/public-lightning/interventions/explorer_view'
                }
            },
            task: {
                content_type: 'task',
                routes: {
                    table_view: '/public-lightning/tasks/table_view',
                    explorer_view: '/public-lightning/tasks/explorer_view',
                    planning_view: '/public-lightning/tasks/planning_view',
                    statistics_view: '/public-lightning/tasks/statistics_view',
                    barcode_view: '/public-lightning/tasks/barcode_view'
                }
            },
            patrimoine: {
                routes: {
                    referentiel: '/public-lightning/referentiel/explorer_view',
                    controls: '/public-lightning/contracts/table_view'
                }
            },
            statistics: {
                routes: {
                    statistics_view: '/public-lightning/statistics_view'
                }
            },
            configuration: {
                routes: {
                    configuration_view: '/public-lightning/configuration_view'
                }
            }
        });

})();
